import http from './utils';
import { prefix } from './constants';

export interface CompetitorsAdCreativesItem {
  creative_id: string;
  app_name: string;
  app_logo: string;
  title: string;
  body: string;
  preview_img: string;
  video_url: string;
  video_duration: number;
  origin_url: string;
  html_url: string;
  store_url: string;
  cta_url: string;
  resources: string;
  type: string[];
  platform: string[];
  channel: string[];
  region: string[];
  countries: string[];
  category: string[];
  source_app: string[];
  impression_number: number;
  like_count: number;
  comment_count: number;
  share_count: number;
  view_count: number;
  interaction_count: number;
  first_seen: string;
  last_seen: string;
  days: number;
  game_id: string;
  material_count: number;
}

export interface CompetitorsAdCreativesMaxStats {
  max_impression_number: number;
  max_like_count: number;
  max_comment_count: number;
  max_share_count: number;
  max_view_count: number;
  max_interaction_count: number;
}

export interface CompetitorsAdCreativesListResponse {
  list: CompetitorsAdCreativesItem[];
  total: number;
  max: CompetitorsAdCreativesMaxStats;
}

/**
 * 竞品广告创意列表
 * POST /api/v1/marketing/materials/list
 */
export const getCompetitorsAdCreativesList = (payload: any) => {
  return http({
    url: `${prefix}/materials/list`,
    method: 'post',
    ...payload,
  }) as Promise<CompetitorsAdCreativesListResponse>;
};

/* ─── ext_info 接口类型 ─── */

export interface IVideoTagChild {
  label_en: string;
  label_zh: string;
}

export interface IVideoTagGroup {
  label_en: string;
  label_zh: string;
  children: IVideoTagChild[];
}

export interface IContentSummary {
  label_en: string;
  label_zh: string;
  summary_en: string;
  summary_zh: string;
}

export interface ITaggingInfo {
  video_url: string;
  video_tags: IVideoTagGroup[];
  content_summary: IContentSummary[];
}

export interface IExtInfoResponse {
  tagging_info: ITaggingInfo[];
}

/**
 * 素材扩展信息（视频标签 & 内容摘要）
 * POST /api/v1/marketing/materials/ext_info
 */
export const getCompetitorsAdCreativesExtInfo = (payload: {
  data: { videos: { video_url: string; game_id: string }[] };
}) => {
  return http({
    url: `${prefix}/materials/ext_info`,
    method: 'post',
    ...payload,
  }) as Promise<IExtInfoResponse>;
};
